import { Button, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './BrokerBanner.css';

interface IBrokerBannerProps {
  loading: boolean;
  onClick(): void;
}

export function BrokerBanner({ loading, onClick }: IBrokerBannerProps) {
  return (
    <div className={styles['container']} data-testid="BrokerBanner">
      <div className={styles['content']}>
        <UIHeading2>Зарабатывайте с Циан</UIHeading2>
        <div className={styles['text']}>
          <UIText1>Продайте квартиру от застройщика и получите вознаграждение по партнёрской программе</UIText1>
        </div>
        <div className={styles['button-wrapper']}>
          <Button loading={loading} onClick={onClick}>
            Хочу заработать
          </Button>
        </div>
      </div>
      <div className={styles['image']} />
    </div>
  );
}
